import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { ReferelCodeActionTypes } from "./constants";

// actions
import { ReferelCodeApiResponseSuccess, ReferelCodeApiResponseError } from "./actions";

// api
import { addCode, updateCode } from "../../helpers/api/referelcode";
import { getCorporates } from "../corporate/actions";
import { getLocations } from "../locations/actions";

// ADD_REFERELCODE
function* addReferelCodeSaga({ payload }: any): SagaIterator {
  try {
    const { type } = payload;
    const response = yield call(addCode, payload);
    const data = response?.data?.message;

    yield put(ReferelCodeApiResponseSuccess(ReferelCodeActionTypes.ADD_REFERELCODE, data));
    if (type == "location") {
      yield put(getLocations());
    } else {
      yield put(getCorporates());
    }
  } catch (error: any) {
    yield put(ReferelCodeApiResponseError(ReferelCodeActionTypes.ADD_REFERELCODE, error));
  }
}

// UPDATE_REFERELCODE
function* updateReferelCodeSaga({ payload }: any): SagaIterator {
  try {
    const { type } = payload;
    const response = yield call(updateCode, payload);
    const data = response?.data?.message;

    yield put(ReferelCodeApiResponseSuccess(ReferelCodeActionTypes.UPDATE_REFERELCODE, data));
    if (type == "location") {
      yield put(getLocations());
    } else {
      yield put(getCorporates());
    }
  } catch (error: any) {
    yield put(ReferelCodeApiResponseError(ReferelCodeActionTypes.UPDATE_REFERELCODE, error));
  }
}

// Watchers
function* watchAddReferelCode() {
  yield takeEvery(ReferelCodeActionTypes.ADD_REFERELCODE, addReferelCodeSaga);
}

function* watchUpdateReferelCode() {
  yield takeEvery(ReferelCodeActionTypes.UPDATE_REFERELCODE, updateReferelCodeSaga);
}

// Root saga
export default function* ReferelCodeSaga() {
  yield all([fork(watchAddReferelCode), fork(watchUpdateReferelCode)]);
}
